import 'vuetify/styles'
import { createVuetify } from 'vuetify'

const vuetify = createVuetify({
    theme: {
        defaultTheme: 'dark',
        themes: {
            dark: {
                dark: true,
                colors: {
                    primary: '#3b82f6',
                    secondary: '#64748b',
                    accent: '#8b5cf6',
                    error: '#ef4444',
                    info: '#06b6d4',
                    success: '#10b981',
                    warning: '#f59e0b',
                    background: '#090d16',
                    surface: '#0f172a',
                },
            },
        },
    },
})

export default vuetify
